import axios from 'axios';
import { DossierId } from '@/dossier/models/AbstractDossier';
import VehicleSearchType from '@/shared/constants/VehicleSearchType';
import DmsSyncStatus from '@/shared/models/DmsSyncStatus';
import Outlet, { OutletId } from '@/shared/models/Outlet';
import { DmsName } from '@/shared/models/common';
import { present } from '@/shared/utils/typescript';
import { parseDmsObjectStatus, parseDmsSyncStatus } from '../converters/dmsConverters';
import DmsObjectStatus from '../models/DmsObjectStatus';

type RepairOrderReference = string;

export interface DmsSearchCriteria {
  outlet: Outlet;
  dmsName?: DmsName;
  externalReference?: RepairOrderReference;
  dmsConnectionName?: string | null
}

export default class DmsClient {
  /**
   * Initiates a search in the DMS for jobs with the given criteria.
   * This process runs in the background and results are communicated via push messages.
   */
  static async searchJobs(criteria: DmsSearchCriteria): Promise<DmsSyncStatus> {
    const params = {
      RepairOrderNr: criteria.externalReference,
      MoboOutletID: criteria.outlet.id,
      ...(!!criteria.dmsName && { dmsname: criteria.dmsName }),
      ...(!!criteria.dmsConnectionName && { dmsconnectionname: criteria.dmsConnectionName }),
    };
    const response = await axios.get('/api/mobopro/v1/dmsrepairorders', { params });
    return present(parseDmsSyncStatus(response.data));
  }

  static async importQuotes(dossierId: DossierId): Promise<DmsSyncStatus> {
    const response = await axios.get(`/api/mobopro/v1/dmsquotes/${dossierId}`);
    return present(parseDmsSyncStatus(response.data));
  }

  static async getDmsObjects(searchType: VehicleSearchType, keyword: string, outletId: OutletId, dmsConnectionName?: DmsName): Promise<DmsObjectStatus> {
    const params = {
      searchtype: searchType,
      keyword,
      moid: outletId,
      ...(!!dmsConnectionName && { dmsconnectionname: dmsConnectionName }),
    };
    const response = await axios.get('/api/mobopro/v2/dmsobjects', { params });
    return present(parseDmsObjectStatus(response.data));
  }
}
